import { render, staticRenderFns } from "./tab8.vue?vue&type=template&id=6cfa7bb2&scoped=true&"
import script from "./tab8.vue?vue&type=script&lang=js&"
export * from "./tab8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfa7bb2",
  null
  
)

export default component.exports